module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-kansai-2-faa70c0b68cf2bc0e6b484674f503a05.png";